import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { RssButtons } from '../../../buttons';
import { usePlayer } from '../../../player';
import { Title } from '../Title';
import type { TrackInfoContentProps } from '../TrackInfoContent';
import { Author } from './Author';

type PodcastTrackInfoProps = Omit<TrackInfoContentProps, 'isVisible'>;

export function PodcastTrackInfo({
  titleTextStyle,
  authorTextStyle,
  wrapTitle,
  track,
  disableTicker
}: PodcastTrackInfoProps) {
  const { layout, position } = useSettings();
  const { currentItem } = usePlayer();

  const isBarLayout = layout === 'floating' && position === 'bottomCenter';
  const derivedTrack = track ?? currentItem;

  return (
    <Container>
      <Title textStyle={titleTextStyle} wrap={wrapTitle} track={derivedTrack} />

      <Author
        textStyle={authorTextStyle}
        isBarLayout={isBarLayout}
        track={derivedTrack}
        isInPlaylist={!!track}
        disableTicker={disableTicker}
      />

      {!isBarLayout && !track && <StyledRssButtons />}
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'players-track-info',
    element: 'container'
  })
})`
  width: fit-content;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const StyledRssButtons = styled(RssButtons).attrs({
  className: createReadableClass({
    component: 'podcast-track-info',
    element: 'rss-buttons'
  })
})`
  margin-top: 4px;
`;
